import { BaseSerializer } from "./baseSerializer.ts";
import { TimePeriods } from "../timePeriods.model.ts";


export class TimePeriodsSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new TimePeriods();
        
        this._copyAttributes(gp, data);

        return gp;

    }

}
